import * as Yup from 'yup';

import { isValidOptionalUrl, requiredString } from './common';

export const APP_ICON_NAME_OPTIONS = [
  { label: 'Halloween', value: 'HALLOWEEN' },
  { label: 'Christmas', value: 'CHRISTMAS' },
  // { label: 'New Year', value: 'NEW_YEAR' },
];

export const APP_ICON_NAMES = APP_ICON_NAME_OPTIONS.map((option) => option.value);

const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

const todayDateValue = () => {
  const now = new Date();
  const pad = (value) => String(value).padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
};

export const appIconFormSchema = Yup.object({
  iconName: Yup.string()
    .required('Select an icon name')
    .oneOf(APP_ICON_NAMES, 'Select an icon name'),
  title: requiredString('Title').trim().max(100, 'Title must be at most 100 characters'),
  iconUrl: requiredString('Icon')
    .trim()
    .max(2048, 'Icon URL is too long')
    .test(
      'icon-url',
      'Upload an icon image',
      (value) => Boolean(String(value || '').trim()) && isValidOptionalUrl(value),
    ),
  startAt: requiredString('Start date')
    .matches(DATE_PATTERN, 'Select a valid start date')
    .test('not-past-start', 'Start date cannot be in the past', (value) => {
      if (!value) return true;
      return value >= todayDateValue();
    }),
  endAt: requiredString('End date')
    .matches(DATE_PATTERN, 'Select a valid end date')
    .test(
      'on-or-after-start',
      'End date cannot be before the start date',
      function onOrAfterStart(value) {
        const { startAt } = this.parent;
        if (!startAt || !value) return true;
        return value >= startAt;
      },
    ),
  isActive: Yup.boolean().required(),
});
